import { Pipe, PipeTransform } from '@angular/core';
import { ClientTypeSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumClientType',
  standalone: false,
})
export class EnumClientTypePipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ClientTypeSchema;

  override transform(value: number | string | undefined): string {
    const val = super.transform(value);

    if (val === 'Custom') {
      return 'Unspecified';
    }

    return val === 'End Client' ? 'Client' : val;
  }
}
